import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
} from '../../themes'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_0};
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .DatePicker {
    background-color: transparent;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
  }
  .DatePicker hr{
    position: relative;
    top: auto;
    left: auto;
    margin: 3px 0;
    padding: 0;
    width: none;
    align-self: stretch;
    border-radius: 6px;
    background-color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
  }
  .DatePicker hr.lightLine{
    border: 1px solid ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
  }
  .calendarButton {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .MonthnYear {
    margin: 0;
    flex: 0;
    color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    width: 100%;
    height: 50px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
  .calendarButton button {
    font-size: ${FONT_SIZE.MMN};
    cursor: pointer;
  }
  .calendarButton h3,
  .MonthnYear h1 {
    text-transform: capitalize;
    padding: 0;
    margin: 0;
  }
  .MonthnYear h1 {
    font-size: ${FONT_SIZE.XXS};
  }
  .calendarButton > button,
  .MonthnYear button {
    flex: 1;
    padding: 0;
    margin: 0;
    border: 0px solid transparent;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
    background-color: transparent;
    border-radius: 3px;
    outline: 0px;
  }
  .calendarButton > button {
    flex: 0;
    min-width: 64px;
    max-width: 64px;
    height: 30px;
    line-height: 1em;
    margin-left: 3px;
    color: white;
  }
  .calendarField section > button p{
    margin-block-start: 0.5em;
    margin-block-end: 0.6em;
  }

  .calendarButton > button.saveButton {
    background-color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    border-radius: 4px;
  }
  .calendarButton > button.closeButton {
    background-color: black;
    border-radius: 4px;
  }

  .calendarButton > button.saveButton:disabled {
    background-color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
  }

  .calendarField {
    flex: 1;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .calendarField > section {
    position: absolute;
    opacity: 1;
    color: black;
    overflow: hidden;
    width: 0;
    height: 0;
    transition: opacity 100ms ease-out, width 1ms ease-out 100ms, height 1ms ease-out 100ms;
    width: 100%;
    height: 100%;
    flex: 1;
    background-color: transparent;
    text-align: center;
    display: grid;
    grid-auto-flow: row;
  }
  .calendarField section.calendarDay {
    grid-template-columns: repeat(7, 1fr);
    grid-auto-rows: 200px;
    justify-content: center;
    align-items: stretch;
    overflow-y: scroll;
  }

  .calendarField section.calendarDay button:nth-child(7n + 1),
  .calendarField section.calendarDay button:nth-child(7n + 7),
  .calendarField section.calendarDay .month-view-holiday{
    background-color: ${COLOR.GRAY_13};
  }

  .calendarField section.calendarDay button {
    border: 0;
    border-bottom: 1px solid ${COLOR.GRAY_5} !important;
    border-right: 1px solid ${COLOR.GRAY_5} !important;
    border-radius: 0px;
  }

  .calendarField section.day-fade {
    grid-template-columns: repeat(7, 14.2%);
    height: 10%;
    justify-content: center;
    align-items: stretch;
  }
  .calendarField section.calendarDay button {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }
  .calendarField section.calendarDay p{
    text-align: center;
    font: 14px Sukhumvit Set;
  }
  .calendarField section.calendarMonth {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 52px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
  }
  .calendarField section.calendarYear {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(7, 36px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
    overflow-y: scroll;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    scrollbar-width: none;
  }
  .calendarField section::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .calendarField section > button {
    font: 12px Sukhumvit Set;
    outline: 0;
    border: 1px solid transparent;
    background: transparent;
    padding: 0;
    line-height: 1em;
    position: relative;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
  }
  .calendarField section > button > h3 {
    padding: 0;
    margin: 0;
  }
  .calendarField section.calendarYear > button {
    border-radius: 3px;
    margin: 0;
  }
  .calendarField section.calendarMonth > button {
    border-radius: 3px;
    margin: 6px 0;
  }
  .calendarField section.calendarDay > button {
    margin: 0;
    overflow: hidden;
  }



  .calendarField section > button:disabled {
    color: #999999;
    cursor: not-allowed;
  }
  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    color: #999999;
  }

  .calendarField section > button.today {
    color: black !important;
    font-weight: 800;
  }

  .calendarField section > button.today p{
    font-weight: 800;
  }

  .calendarField section > button::before {
    color: black;
    font: 16px Sukhumvit Set;
  }

  .calendarField section > button.prevCar::before,
  .calendarField section > button.nextCar::before,
  .calendarField section > button.today::before,
  .calendarField section > button.currentCar::before {
    color: ${COLOR.GRAY_20};
    text-transform: uppercase;
  }
  .calendarField section > button.prevCar:nth-child(1)::before,
  .calendarField section > button.nextCar:nth-child(1)::before,
  .calendarField section > button.today:nth-child(1)::before,
  .calendarField section > button.currentCar:nth-child(1)::before {
    content: '${props => props.dayInWeek[0]}';
  }
  .calendarField section > button.prevCar:nth-child(2)::before,
  .calendarField section > button.nextCar:nth-child(2)::before,
  .calendarField section > button.today:nth-child(2)::before,
  .calendarField section > button.currentCar:nth-child(2)::before {
    content: '${props => props.dayInWeek[1]}';
  }
  .calendarField section > button.prevCar:nth-child(3)::before,
  .calendarField section > button.nextCar:nth-child(3)::before,
  .calendarField section > button.today:nth-child(3)::before,
  .calendarField section > button.currentCar:nth-child(3)::before {
    content: '${props => props.dayInWeek[2]}';
  }
  .calendarField section > button.prevCar:nth-child(4)::before,
  .calendarField section > button.nextCar:nth-child(4)::before,
  .calendarField section > button.today:nth-child(4)::before,
  .calendarField section > button.currentCar:nth-child(4)::before {
    content: '${props => props.dayInWeek[3]}';
  }
  .calendarField section > button.prevCar:nth-child(5)::before,
  .calendarField section > button.nextCar:nth-child(5)::before,
  .calendarField section > button.today:nth-child(5)::before,
  .calendarField section > button.currentCar:nth-child(5)::before {
    content: '${props => props.dayInWeek[4]}';
  }
  .calendarField section > button.prevCar:nth-child(6)::before,
  .calendarField section > button.nextCar:nth-child(6)::before,
  .calendarField section > button.today:nth-child(6)::before,
  .calendarField section > button.currentCar:nth-child(6)::before {
    content: '${props => props.dayInWeek[5]}';
  }
  .calendarField section > button.prevCar:nth-child(7)::before,
  .calendarField section > button.nextCar:nth-child(7)::before,
  .calendarField section > button.today:nth-child(7)::before,
  .calendarField section > button.currentCar:nth-child(7)::before {
    content: '${props => props.dayInWeek[6]}';
  }

  .calendarField section > button.today > p {
    color: ${COLOR.WHITE} !important;
    background: ${COLOR.BLACK_1};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    text-align: center;
    margin: 0 auto 0.6em auto;
    line-height: 32px;
  }

  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    background-color: transparent;
    border-top : 4px solid transparent;
  }
  .slide-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: slide-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes slide-in {
    0% {
      max-height: 0%;
      opacity: 0.5;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
  .fade-out {
    animation-timing-function: ease-in;
    animation-duration: 100ms;
    animation-name: fade-out;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .fade-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: fade-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes jump-in {
    0% {
      max-height: 0vh;
      max-width: 0vw;
      top: 50%;
      left: 50%;
      opacity: 0;
    }
    100% {
      max-height: 100vh;
      max-width: 100vw;
      top: 0;
      left: 0;
      opacity: 1;
    }
  }
  .selectDate .left {
    padding-right: 8px;
  }
  .arrow {
    width: 95px;
    text-align: end;
    display: flex;
    background-color: transparent;
    position: absolute;
    margin-left: 160px;
  }
  .arrow h1 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 6px;
    width: 44px;
    text-align: center;
  }
  .arrow button  {
    flex: 0;
  }
  .selectDate {
    padding-left: 24px;
  }
  .selectDateThin {
    padding-left: 52px;
    padding-bottom: 16px;
  }
  .selectDateThin h1{
    font-weight: 100;
  }
  .list-booking {
    color: black;
  }
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 2px 10px;
    span {
      white-space: pre;
      font: 12px/19px Sukhumvit Set;
    }
    svg {
      margin-right: 8px;
      width: 10px;
      fill: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    }
  }
  .more {
    color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    span {
      font-family: NunitoBold;
      font-size: ${FONT_SIZE.TN}
    }
  }
  .list-booking :hover{
    background-color: ${COLOR.PEARL} ;
  }
  .table-booking {
    width: 100%;
    height: auto;
  }
  .title-holiday {
    background-color: ${COLOR.GRAY_5};
    border-radius: 6px;
    color: ${COLOR.BLACK_1};
    display: flex;
    font-weight:normal;
    margin: 4px 5px;
    padding: 2px 10px;
    opacity: 1;
    white-space: nowrap;
    overflow: hidden;
  }

  .alive {
    border-radius: 4px;
    background: ${({ colorTheme }) => colorTheme ? `${colorTheme}a0` : COLOR.GOLD_1};
  }
  .alive:hover {
    background: ${({ colorTheme }) => colorTheme ? `${colorTheme}a0` : COLOR.GOLD_1};
  }

  .alive > .title > .sub_title {
    color: ${COLOR.BLACK_1};
  }
`

export default Style
